import images from '_images';
import styled from 'styled-components';
import { primaryColor } from '../app/apis';

const { checked } = images;

const RadioBox = styled.div`
  background-color: #D8E4E7;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  
  &.selected {
    background-color: ${primaryColor};
    background-image: url(${checked});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 12px;
  }
`;

export default RadioBox;
